import { Component, OnChanges, SimpleChanges, Input, OnInit } from '@angular/core';//, ChangeDetectorRef
import { CommonFilterService } from '../../services/common-filter/common-filter.service';
//import { DatePipe } from '@angular/common'
import { DemoService } from '../../demo.service';
import { formatDBTZDateToLocalDate } from 'lib/common';
import { stream } from 'exceljs';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit { //OnChanges {
  @Input() title: string;
  @Input() staticScreen: boolean;
  dates: string = "";
  rangeInfo: string = "Last 10 Minutes";
  prevRangeInfo: string = "Last 10 Minutes";
  //formatedDate: Date;
  constructor(private commonFilterService: CommonFilterService, private service: DemoService) {//, private cd: ChangeDetectorRef) {//, public datepipe: DatePipe) {
    this.updateScreen();
  }
  ngOnInit() {
    //this.cd.detectChanges();
  }
  //ngOnChanges(changes: SimpleChanges) {// change from oninit to onchanges to get latest input chnaged by its parent comp - IMP
  //  //if (!this.staticScreen) {
  //  //  this.commonFilterService.TSBetween.subscribe(res => {
  //  //    debugger;
  //  //    setTimeout(() => {
  //  //      this.dates = ' between ' + res.replace('^', ' and ');
  //  //    });
  //  //  }
  //  //  );
  //  //  this.commonFilterService.TSRangeFilter.subscribe(res => this.rangeInfo = res);
  //  //  //console.log(this.rangeInfo)
  //  //}
  //}
  async updateScreen() {
    if (!this.staticScreen) {

      let MainFilterTZ = 0;
      this.commonFilterService.mfTZ.subscribe(res => MainFilterTZ = res);// set mainfilter ID

      let dbTz = -500;
      //this.commonFilterService.DB_TZ.subscribe(res => {
      //  dbTz = res;
      //});
      //if (dbTz == -500) {//query var col table
      //  await this.service.getDBTimezoneDiff('VquadData').then(res => {
      //    this.commonFilterService.setDBTZFromVarCol(res);
      //    dbTz = res;
      //  });
      //}
      ////console.log(dbTz)
      //debugger;
      let dbAndBrHrs = -500;
      //if (this.commonFilter.MainFilterID != 0) {
      this.commonFilterService.DB_BRDiff.subscribe(res => {
        dbAndBrHrs = res;
      });
      if (dbAndBrHrs == -500) {//query var col table
        await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
          this.commonFilterService.setDBAndBrowserHrsDiff(res);
          dbAndBrHrs = res;
        });
      }
      //}


      //// set custom date from selected mainfilter
      let mainFilterDateOrNot = false;
      this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res1 => {
        //debugger;
        //check if mainfilter has custom date or not
        mainFilterDateOrNot = res1;
        this.commonFilterService.mfDateTime.subscribe(resmf => {
          if (resmf != "") {
            ////this.dates = ' between ' + resmf.replace(';', ' and ');

            // let dt = res.split('^')[0];
            //this.formatedDate = new Date(dt);
            // let latest_date = this.datepipe.transform(this.formatedDate, 'MM-dd-yyyy');
            //this.dates = ' between ' + this.datepipe.transform(new Date(resmf.split(';')[0]), 'MM/dd/yyyy HH:mm:ss') + ' and ' + this.datepipe.transform(new Date(resmf.split(';')[1]), 'MM/dd/yyyy HH:mm:ss');
            let datesArr = resmf.split(';');
            let startDate = formatDBTZDateToLocalDate(datesArr[0], dbTz, dbAndBrHrs, MainFilterTZ);
            let endDate = formatDBTZDateToLocalDate(datesArr[1], dbTz, dbAndBrHrs, MainFilterTZ);
            this.dates = ' between ' + startDate + ' and ' + endDate;
            this.rangeInfo = "Custom range - Filter";
          }
          else
            this.rangeInfo = this.prevRangeInfo;
        });
      });


      this.commonFilterService.TSRangeFilter.subscribe(res => {
        if (!mainFilterDateOrNot) {
          //setTimeout(() => {
          this.rangeInfo = res.RangeSelected;
          this.prevRangeInfo = this.rangeInfo;
          //});
        }
      });
      this.commonFilterService.TSBetween.subscribe(res => {
        if (!mainFilterDateOrNot) {
          let datesArr = res.split('^');
          let startDate = formatDBTZDateToLocalDate(datesArr[0], dbTz, dbAndBrHrs, MainFilterTZ);
          let endDate = formatDBTZDateToLocalDate(datesArr[1], dbTz, dbAndBrHrs, MainFilterTZ);
          //this.dates = ' between ' + res.replace('^', ' and ');
          setTimeout(() => {//https://stackoverflow.com/questions/53127074/angular-material-change-detection-using-ngonchanges-throwing-error-expressionc - IMP
            this.dates = ' between ' + startDate + ' and ' + endDate;
          });
          //this.dates = ' between ' + this.datepipe.transform(new Date(moment().subtract(10, 'minutes').toString()), 'MM-dd-yyyy HH:mm:ss') + ' and ' + this.datepipe.transform(new Date(moment().toString()), 'MM-dd-yyyy HH:mm:ss');
        }
      });
      //console.log(this.rangeInfo)
    }
  }
}
